import React, { FC } from 'react'

import { IconAppsProps } from './IconApps.types'
import * as Styled from './styles/IconApps.style'

import { nonThemeableRules } from '../../ruleSet'

const IconApps: FC<IconAppsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAppsProps['size'],
  isResponsive = false,
}: IconAppsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M20.777 35.633h-7.87a1.411 1.411 0 0 1-1.25-.65 1.38 1.38 0 0 1 .03-1.4l3.94-7.458a1.315 1.315 0 0 1 2.388 0l4 7.455a1.373 1.373 0 0 1 .03 1.4 1.407 1.407 0 0 1-1.268.653Zm-3.934-14.318a4.475 4.475 0 1 1-.006-8.95 4.475 4.475 0 0 1 .006 8.95Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m31.158 25.118 5.257 4.207-2.102 6.308h-6.308l-2.102-6.308 5.255-4.207Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M33.645 12.368h-4.972c-1.098 0-1.988.89-1.988 1.987v4.973c0 1.097.89 1.987 1.988 1.987h4.972c1.098 0 1.988-.89 1.988-1.987v-4.973c0-1.098-.89-1.987-1.988-1.987Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M11 7h30v30a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4Z' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconApps
